import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

import { BaseTile } from "../enums/BaseTile";
import { Risk } from "../enums/Risk";
import * as axiosHelper from "../utils/axiosHelper";
import moment from "moment";
import { OBSERVATORY } from "../enums/Type";
import axios from "axios";

const DATE_FORMAT = "YYYY/MM/DD HH:mm";
const storage = localStorage.getItem("ob-markers");
const enabledObservatories = storage
  ? JSON.parse(storage)
  : [OBSERVATORY.STAGE.code, OBSERVATORY.RAIN.code, OBSERVATORY.CAMERA.code];

export default new Vuex.Store({
  state: {
    mobileHazardMap: {
      key: null,
      detail: []
    },
    isShowMobileHazardMap: false,
    user: {},
    baseDate: moment.utc(),
    selectedRisk: Risk.RAIN,
    selectedBaseTile: BaseTile.GRAY,
    selectedFeatures: [],
    selectedObservatory: {},
    selectedDate: moment.utc(),
    riskBaseDate: moment.utc(),
    leafletMap: null,
    isShowMapDetail: false,
    mapDetail: {
      title: "",
      contents: ""
    },
    observatories: [],
    isShowUsageGuide: false,
    imageSizeInfo: {},
    rainImageCoordinate: {},
    rainImageInfo: [],
    riskSubControl: {
      observatory: enabledObservatories,
      opacity: 0.7
    },
    riverFloodingInfo: [],
    riverFloodingType: 3,
    dosyaInfo: {
      bounds: [],
      images: []
    },
    snowInfo: {},
    usageGuide: {
      title: null,
      colors: []
    },
    hazardMapUsageGuide: {
      url: []
    },
    alerts: [],
    isNavigationVisible: false,
    isRightNavVisible: false,
    isMonitoring: true,
    isWeather: false,
    isCameraMonitor: false,
    kouzuiInfo: [],
    isLoading: false,
    wind: {
      timeSeries: [],
      data: {}
    },
    selectedWind: {
      speed: 0,
      direction: 0
    },
    isMobileObservatoryRisk: true,
    isChronology: false,
    chronologies: [],
    selectedChronology: null,
    serviceWorkerRegistration: null
  },
  getters: {
    mobileHazardMap: state => state.mobileHazardMap,
    baseDate: state => state.baseDate,
    user: state => state.user,
    selectedRisk: state => state.selectedRisk,
    selectedBaseTile: state => state.selectedBaseTile,
    selectedFeatures: state => state.selectedFeatures,
    selectedObservatory: state => state.selectedObservatory,
    selectedDate: state => state.selectedDate,
    riskBaseDate: state => state.riskBaseDate,
    imageSizeInfo: state => state.imageSizeInfo,
    rainImageInfo: state => state.rainImageInfo,
    rainImageCoordinate: state => state.rainImageCoordinate,
    leafletMap: state => state.leafletMap,
    isShowMapDetail: state => state.isShowMapDetail,
    mapDetail: state => state.mapDetail,
    observatories: state => state.observatories,
    riskSubControl: state => state.riskSubControl,
    isShowUsageGuide: state => state.isShowUsageGuide,
    riverFloodingInfo: state => state.riverFloodingInfo,
    riverFloodingType: state => state.riverFloodingType,
    dosyaInfo: state => state.dosyaInfo,
    snowInfo: state => state.snowInfo,
    usageGuide: state => state.usageGuide,
    hazardMapUsageGuide: state => state.hazardMapUsageGuide,
    alerts: state => state.alerts,
    isShowMobileHazardMap: state => state.isShowMobileHazardMap,
    isNavigationVisible: state => state.isNavigationVisible,
    isRightNavVisible: state => state.isRightNavVisible,
    isMonitoring: state => state.isMonitoring,
    isCameraMonitor: state => state.isCameraMonitor,
    isWeather: state => state.isWeather,
    kouzuiInfo: state => state.kouzuiInfo,
    isLoading: state => state.isLoading,
    wind: state => state.wind,
    selectedWind: state => state.selectedWind,
    isMobileObservatoryRisk: state => state.isMobileObservatoryRisk,
    isChronology: state => state.isChronology,
    chronologies: state => state.chronologies,
    selectedChronology: state => state.selectedChronology,
    serviceWorkerRegistration: state => state.serviceWorkerRegistration
  },
  mutations: {
    SET_MOBILE_HAZARD_MAP: function(state, payload) {
      state.mobileHazardMap = payload;
    },
    SET_BASE_DATE: function(state, payload) {
      state.baseDate = payload;
    },
    SET_SELECTED_RISK: function(state, payload) {
      state.selectedRisk = payload;
    },
    SET_SELECTED_FEATURES: function(state, payload) {
      state.selectedFeatures = payload;
    },
    SET_SELECTED_BASE_TILE: function(state, payload) {
      state.selectedBaseTile = payload;
    },
    SET_LEAFLET_MAP: function(state, payload) {
      state.leafletMap = payload;
    },
    SET_ALERTS: function(state, payload) {
      state.alerts = payload;
    },
    SET_OBSERVATORIES: function(state, payload) {
      state.observatories = payload;
    },
    SET_SELECTED_OBSERVATORY: function(state, payload) {
      state.selectedObservatory = payload;
    },
    SET_SELECTED_DATE: function(state, payload) {
      state.selectedDate = payload;
    },
    SET_RAIN_IMAGE_COORDINATE: function(state, payload) {
      state.rainImageCoordinate = payload;
    },
    SET_RAIN_IMAGE_INFO: function(state, payload) {
      state.rainImageInfo = payload;
    },
    SET_IMAGE_SIZE_INFO: function(state, payload) {
      state.imageSizeInfo = payload;
    },
    SET_RISK_BASE_DATE: function(state, payload) {
      state.riskBaseDate = payload;
    },
    SET_MAP_DETAIL: function(state, payload) {
      state.isShowMapDetail = payload.isShowing;
      state.mapDetail.title = payload.title;
      state.mapDetail.contents = payload.contents;
    },
    SET_RISK_SUB_CONTROL(state, payload) {
      const cloneRiskSubControl = Object.assign({}, state.riskSubControl);
      if (payload.observatory !== undefined) {
        cloneRiskSubControl.observatory = payload.observatory;
      }
      if (payload.opacity !== undefined) {
        cloneRiskSubControl.opacity = payload.opacity;
      }
      state.riskSubControl = cloneRiskSubControl;
    },
    ["SET_IS_SHOW_USAGE_GUIDE"](state, payload) {
      state.isShowUsageGuide = payload;
    },
    ["SET_SELECTED_AROUND_OBSERVATORIES"](state, payload) {
      state.selectedAroundObservatories = payload.observatories;
    },
    ["SET_RIVER_FLOODING_INFO"](state, payload) {
      state.riverFloodingInfo = payload;
    },
    SET_RIVER_FLOODING_TYPE: function(state, payload) {
      state.riverFloodingType = payload;
    },
    SET_DOSYA_INFO: function(state, payload) {
      state.dosyaInfo = payload;
    },
    SET_SNOW_INFO: function(state, payload) {
      state.snowInfo = payload;
    },
    SET_COGNITO_USER_INFO: function(state, payload) {
      state.user = payload;
    },
    SET_USAGE_GUIDE(state, payload) {
      state.usageGuide = payload;
    },
    SET_HAZARD_MAP_USAGE_GUIDE: function(state, payload) {
      state.hazardMapUsageGuide = payload;
    },
    SET_IS_SHOW_MOBILE_HAZARD_MAP: function(state, payload) {
      state.isShowMobileHazardMap = payload;
    },
    SET_IS_NAVIGATION: function(state, payload) {
      state.isNavigationVisible = payload;
    },
    SET_IS_RIGHT_NAV: function(state, payload) {
      state.isRightNavVisible = payload;
    },
    SET_IS_MONITORING: function(state, payload) {
      state.isMonitoring = payload;
    },
    SET_IS_WEATHER: function(state, payload) {
      state.isWeather = payload;
    },
    SET_IS_CAMERA_MONITOR: function(state, payload) {
      state.isCameraMonitor = payload;
    },
    SET_KOUZUI_INFO: function(state, payload) {
      state.kouzuiInfo = payload;
    },
    SET_IS_LOADING: function(state, payload) {
      state.isLoading = payload;
    },
    SET_WIND_TIME_SERIES: function(state, payload) {
      state.wind.timeSeries = payload;
    },
    SET_WIND_DATA: function(state, payload) {
      state.wind.data = payload;
    },
    SET_SELECTED_WIND: function(state, payload) {
      state.selectedWind = payload;
    },
    SET_IS_MOBILE_OBSERVATORY_RISK: function(state, payload) {
      state.isMobileObservatoryRisk = payload;
    },
    SET_IS_CHRONOLOGY: function(state, payload) {
      state.isChronology = payload;
    },
    SET_CHRONOLOGIES: function(state, payload) {
      state.chronologies = payload;
    },
    SET_SELECTED_CHRONOLOGY: function(state, payload) {
      state.selectedChronology = payload;
    },
    SET_SERVICE_WORKER_REGISTRATION: function(state, payload) {
      state.serviceWorkerRegistration = payload;
    }
  },
  actions: {
    FETCH_OBSERVATORIES: async function(context) {
      const baseDate = this.state.baseDate.clone();
      baseDate.subtract(baseDate.minute() % 5, "minutes");

      let observatories = [];
      const res = await axiosHelper.get("/observatories", {
        domain: "hodatsushimizu.riskma.jp"
      });
      if (res === null || !res.observatories) {
        context.commit("SET_OBSERVATORIES", []);
        return;
      }

      observatories = res.observatories;
      observatories.forEach(obs => {
        if (
          obs.type === OBSERVATORY.CAMERA.code ||
          obs.type === OBSERVATORY.LIVECAMERA.code ||
          obs.type === OBSERVATORY.DAM.code
        ) {
          obs.status = "normal";
        } else {
          obs.status = "deficit";
        }
      });
      // 夏季限定のカメラ除外
      const jstMonth =
        baseDate
          .clone()
          .add(9, "hours")
          .month() + 1;
      if (jstMonth >= 4 && jstMonth <= 10) {
        observatories = observatories.filter(
          obs =>
            obs.type !== OBSERVATORY.CAMERA.code ||
            !obs.id.startsWith("99_17000_3_")
        );
      }

      const params = {
        domain: "hodatsushimizu.riskma.jp",
        date: baseDate.format(DATE_FORMAT)
      };
      const response = await axiosHelper.get(
        "/observatories/status/v2",
        params
      );
      if (response !== null) {
        const rains = response.rains;
        const stages = response.stages;
        const winds = response.winds;
        const snows = response.snows;

        observatories.forEach(obs => {
          const obsId = obs.id;
          if (obs.type === OBSERVATORY.RAIN.code) {
            obs.status = "deficit";
            delete obs.min10;
            delete obs.total;
            if (rains[obsId] !== undefined) {
              if (rains[obsId].min10 !== undefined) {
                const min10 = rains[obsId].min10;
                obs.min10 = min10;
                if (min10 >= 20) {
                  obs.status = "4";
                } else if (min10 >= 10) {
                  obs.status = "3";
                } else if (min10 >= 5) {
                  obs.status = "2";
                } else if (min10 >= 1) {
                  obs.status = "1";
                } else if (min10 >= 0) {
                  obs.status = "0";
                }
              }
              if (rains[obsId].total !== undefined) {
                obs.total = rains[obsId].total;
              }
            }
          } else if (obs.type === OBSERVATORY.STAGE.code) {
            obs.status = "deficit";
            delete obs.level;
            delete obs.chartWaterBoxLevel;
            if (
              stages[obsId] !== undefined &&
              stages[obsId].level !== undefined
            ) {
              const level = stages[obsId].level;
              const date = stages[obsId].date;
              const targetDate = baseDate
                .clone()
                .subtract(30, "minutes")
                .format(DATE_FORMAT);
              if (obs.kiki === true && date < targetDate) {
                obs.chartWaterBoxLevel = level;
              } else {
                obs.level = level;
                if (
                  obs.outbreakLevel !== undefined &&
                  level >= obs.outbreakLevel
                ) {
                  obs.status = "outbreak";
                } else if (
                  obs.floodLevel !== undefined &&
                  level >= obs.floodLevel
                ) {
                  obs.status = "outbreak";
                } else if (
                  obs.dangerousLevel !== undefined &&
                  level >= obs.dangerousLevel
                ) {
                  obs.status = "dangerous";
                } else if (
                  obs.warnLevel !== undefined &&
                  level >= obs.warnLevel
                ) {
                  obs.status = "dangerous";
                } else if (
                  obs.evacuationLevel !== undefined &&
                  level >= obs.evacuationLevel
                ) {
                  obs.status = "evacuation";
                } else if (
                  obs.warningLevel !== undefined &&
                  level >= obs.warningLevel
                ) {
                  obs.status = "warning";
                } else if (
                  obs.standbyLevel !== undefined &&
                  level >= obs.standbyLevel
                ) {
                  obs.status = "standby";
                } else if (
                  obs.startLevel !== undefined &&
                  level >= obs.startLevel
                ) {
                  obs.status = "start";
                } else {
                  obs.status = "normal";
                }
              }
            }
          } else if (obs.type === OBSERVATORY.WIND.code) {
            if (
              winds[obsId] !== undefined &&
              winds[obsId].speed !== undefined &&
              winds[obsId].direction !== undefined
            ) {
              obs.status = {
                speed: winds[obsId].speed,
                direction: winds[obsId].direction
              };
            }
          } else if (obs.type === OBSERVATORY.SNOW.code) {
            obs.status = null;
            if (
              snows[obsId] !== undefined &&
              snows[obsId].snow_total !== undefined
            ) {
              obs.status = snows[obsId].snow_total;
            }
          }
        });
      }
      context.commit("SET_OBSERVATORIES", observatories);
    },
    FETCH_SELECTED_OBSERVATORY_DATA: async function(context, target) {
      const observatory = Object.assign({}, target);
      const baseDate = this.state.baseDate.clone();
      const params = {
        date: baseDate.format(DATE_FORMAT),
        id: observatory.id,
        type: observatory.type,
        rain_forecast: observatory.type === 1
      };
      if (observatory.type === OBSERVATORY.RAIN.code) {
        params.hours = "24";
      }
      if (observatory.type === OBSERVATORY.WIND.code) {
        params.hours = "24";
      }
      if (observatory.type === OBSERVATORY.SNOW.code) {
        params.hours = "24";
      }

      if (observatory.dynamodb) {
        params["dynamodb"] = observatory.dynamodb;
      }
      if (observatory.bucket) {
        params["bucket"] = observatory.bucket;
      }
      if (observatory.prefix) {
        params["prefix"] = observatory.prefix;
      }

      const response = await axiosHelper.get("/observatories/data", params);
      if (response === null) {
        throw new Error("fetch failed : observatories/data");
      }

      const selected = Object.assign({}, target);
      selected.baseDate = response.baseDate;
      selected.timeSeries = response.timeSeries;

      let contents = "";
      let title = "";
      const observatoryName = selected.name === undefined ? "" : selected.name;
      switch (selected.type) {
        case OBSERVATORY.RAIN.code:
          contents = "rainfall-detail";
          title = `${OBSERVATORY.RAIN.name}観測所 - ${observatoryName}`;
          break;
        case OBSERVATORY.STAGE.code:
          contents = "stage-detail";
          title = `${OBSERVATORY.STAGE.name}観測所 - ${observatoryName}`;
          break;
        case OBSERVATORY.DAM.code:
          contents = "dam-detail";
          title = `${OBSERVATORY.DAM.name}観測所 - ${observatoryName}`;
          break;
        case OBSERVATORY.CAMERA.code:
          contents = "camera-detail";
          title = `${OBSERVATORY.CAMERA.name}`;
          break;
        case OBSERVATORY.LIVECAMERA.code:
          contents = "live-camera-detail";
          title = `${OBSERVATORY.LIVECAMERA.name}`;
          break;
        case OBSERVATORY.WIND.code:
          contents = "wind-detail";
          title = `${OBSERVATORY.WIND.name}観測所 - ${observatoryName}`;
          break;
        case OBSERVATORY.SNOW.code:
          contents = "snow-detail";
          title = `${OBSERVATORY.SNOW.name}観測所 - ${observatoryName}`;
          break;
      }
      context.commit("SET_SELECTED_OBSERVATORY", selected);

      context.commit("SET_MAP_DETAIL", {
        isShowing: true,
        title: title,
        contents: contents
      });
    },
    FETCH_RIVER_FLOODING: async function(context) {
      const baseDate = this.state.baseDate.clone();
      baseDate.subtract(baseDate.minute() % 5, "minutes");

      const parameters = {
        date: baseDate.utc().format(DATE_FORMAT)
      };

      const response = await axiosHelper.get("/river-floods", parameters);
      if (response === null) {
        throw new Error("fetch failed : river-floods");
      }

      context.commit(
        "SET_RISK_BASE_DATE",
        moment.utc(response.baseDate, DATE_FORMAT)
      );
      const areas = response.areas.map(area => area);
      context.commit("SET_RIVER_FLOODING_INFO", areas);

      context.commit(
        "SET_SELECTED_DATE",
        moment.utc(response.baseDate, DATE_FORMAT)
      );
    },
    FETCH_DOSYA: async function(context) {
      const baseDate = this.state.baseDate.clone();
      baseDate.subtract(baseDate.minute() % 10, "minutes");

      const params = {
        date: baseDate.utc().format(DATE_FORMAT)
      };
      const res = await axiosHelper.get("/dosya", params);
      if (res === null) {
        context.commit("SET_DOSYA_INFO", {});
        return;
      }
      const dosyaInfo = {
        bounds: [],
        imageInfos: [],
        size: {}
      };
      if (!res.imageInfos) {
        context.commit("SET_DOSYA_INFO", dosyaInfo);
        return;
      }

      dosyaInfo.bounds = res.bounds;

      const loadImage = src => {
        return new Promise(resolve => {
          const image = new Image();
          image.onload = () => resolve(image);
          image.onerror = () => resolve(null);
          image.src = src;
        });
      };

      const infos = res.imageInfos.map(async info => {
        const image = await loadImage(info.url);
        return {
          date: info.date,
          image: image,
          url: info.url
        };
      });
      const infosRes = await Promise.all(infos);
      dosyaInfo.images = infosRes.filter(row => row.image !== null);
      context.commit("SET_DOSYA_INFO", dosyaInfo);

      context.commit(
        "SET_RISK_BASE_DATE",
        moment.utc(res.baseDate, DATE_FORMAT)
      );

      context.commit(
        "SET_SELECTED_DATE",
        res.baseDate ? moment.utc(res.baseDate, DATE_FORMAT) : baseDate
      );
    },
    FETCH_SNOW: async function(context) {
      let baseDate = this.state.baseDate.clone();
      baseDate.subtract(baseDate.minute() % 10, "minutes");

      const params = {
        date: baseDate.utc().format(DATE_FORMAT)
      };

      axios
        .create({
          responseType: "json"
        })
        .get("https://data.riskma.net/bosai/snow", { params })
        .then(async response => {
          const res = response.data;

          const snowInfo = {
            bounds: [],
            imageInfos: [],
            size: {}
          };
          if (!res.imageInfos) {
            context.commit("SET_SNOW_INFO", snowInfo);
            return;
          }

          snowInfo.bounds = res.bounds;
          snowInfo.size = res.size;

          const loadImage = src => {
            return new Promise(resolve => {
              const image = new Image();
              image.onload = () => resolve(image);
              image.onerror = () => resolve(null);
              image.src = src;
            });
          };

          const infos = res.imageInfos.map(async info => {
            const image = await loadImage(info.url);
            return {
              date: info.date,
              image: image
            };
          });
          const infosRes = await Promise.all(infos);
          snowInfo.imageInfos = infosRes.filter(row => row.image !== null);
          context.commit("SET_SNOW_INFO", snowInfo);

          context.commit(
            "SET_RISK_BASE_DATE",
            moment.utc(res.baseDate, DATE_FORMAT)
          );

          baseDate = res.baseDate
            ? moment.utc(res.baseDate, DATE_FORMAT)
            : baseDate;
          context.commit("SET_SELECTED_DATE", baseDate);
        })
        .catch(err => {
          console.log(err);
        });
    },
    REFRESH_SERVICE_WORKER_REGISTRATION: async context => {
      if (!context.getters.serviceWorkerRegistration) return;
      const swRegistration = context.getters.serviceWorkerRegistration;
      if (swRegistration.waiting) {
        swRegistration.waiting.postMessage({
          type: "SKIP_WAITING"
        });
      }
      await swRegistration.update();
    }
  }
});
